import script from "./ProductMappings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductMappings.vue?vue&type=script&setup=true&lang=js"

import "./ProductMappings.vue?vue&type=style&index=0&id=4b754e45&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b754e45"]])

export default __exports__